var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"align-center",attrs:{"id":"wrapper","fluid":"","fill-height":""}},[_c('v-layout',{staticClass:"align-center justify-center"},[_c('v-flex',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }